export function isEnergySavingTool(deviceType: string | undefined): boolean {
	if (!deviceType) return false;

	const energySavingToolTypes: string[] = ['energySavingTool', 'EST City', 'EST Site'];
	return energySavingToolTypes.includes(deviceType);
}
